module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nsouls_m.9fab60dbc57fa65a91f9d432aad72d33.png";